import $ from 'jquery';
import 'slick-carousel';
import flatpickr from "flatpickr";
import Cookies from 'js-cookie';

export default function residentialCollections() {
    //Mobile nav visiblityy
    if ($('.nav-overlay').is(':visible')) {
        $('body').addClass("fixed");
     } else {
        $('body').removeClass("fixed");
     }

    const hamburgerButton = document.querySelector('button.hamburger');
    hamburgerButton.addEventListener('click', function(e) {
        hamburgerButton.classList.toggle('is-active');

        e.preventDefault();
        if ($('.hamburger').hasClass('is-active')) {
            $('.nav-overlay').fadeIn('fast');
        } else {
            $('.nav-overlay').fadeOut('fast');
        }
	})


    //Postcode checker
    $('.valid-postcode').hide();
    $('.invalid-postcode').hide();

    $( ".check-postcode" ).click(function(e) {
        e.preventDefault();
        $('.valid-postcode').hide();
        $('.invalid-postcode').hide();
        $.post(
            "/residential-collections/api/validate-postcode",
            $('.postcode_form').serialize(),
            function(data) {
                if (parseInt(data) === 1) {
                    $('.valid-postcode').fadeIn();
                } else {
                    $('.invalid-postcode').fadeIn();
                }
            });
      });

      $('.residential-waste-slider').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          autoplay: true,
          autoplaySpeed: 3000,
      });

    if (document.querySelector('[name="preferred_start_date"]')) {
        flatpickr(document.querySelector('[name="preferred_start_date"]'), {
            dateFormat: "d M Y",
            minDate: new Date().fp_incr(4),
            onClose: function(selectedDates, dateStr, instance){
                Cookies.set('gg-psd', dateStr)
             }
        });
    }

    //Populate the selected date on the checkout page
    if (document.querySelector('.woocommerce-additional-fields') && document.querySelector('[name="preferred_start_date"]')) {
        document.querySelector('[name="preferred_start_date"]').value = Cookies.get('gg-psd');
    }

    //Pricing Toggle
    $('#price-toggle').on('change', function(e) {
        e.preventDefault();
        if ($(this).is(':checked')) {
            //Show the annual pricing
            $('.price-monthly').hide();
            $('.price-annual').fadeIn();
        } else {
            //Show the monthly pricing
            $('.price-annual').hide();
            $('.price-monthly').fadeIn();
        }
    });

    //Work out price to show at foot of sign up page
    let classname = document.getElementsByClassName("calc-price")
    let waste = 0;
    let bin = 0;
    let recycling = 0;

    Array.from(classname, c => c.addEventListener("change", function (e) {
        e.preventDefault();

        if (e.currentTarget.getAttribute('data-bin-price')) {
            bin = Number(e.currentTarget.getAttribute('data-bin-price'));
        }

        if (e.currentTarget.getAttribute('data-waste-collections-price')) {
            waste = Number(e.currentTarget.getAttribute('data-waste-collections-price'));
        }

        if (e.currentTarget.getAttribute('data-recycling-collections-price')) {
            recycling = Number(e.currentTarget.getAttribute('data-recycling-collections-price'));
        }

        //Stick the formatted sum into the container
        let total = waste+bin+recycling;
        document.querySelector('.calculated-price').innerHTML = Number((total).toFixed(2)).toLocaleString();
    }));
}
